module.exports = __webpack_public_path__ + "img/scuba_1920.2cc5cfd3.png";